"use strict";
var ESCAPE_LOOKUP = {
  "&": "&amp;",
  ">": "&gt;",
  "<": "&lt;",
  '"': "&quot;",
  "'": "&#x27;"
};
var ESCAPE_REGEX = /[&><"']/g;
function escaper(match) {
  return ESCAPE_LOOKUP[match];
}
function escapeTextContentForBrowser(text) {
  return ("" + text).replace(ESCAPE_REGEX, escaper);
}
module.exports = escapeTextContentForBrowser;
